import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_rateCardsList = (request) => {
    let ENDPOINT = URL_BASE_API+'affiliate/rate-card/';
    if(request.data!==undefined){
        let pageId = request.data.page;
        let column = request.data.column;
        let pageSize = request.data.pageSize;
        ENDPOINT = URL_BASE_API+'affiliate/rate-card/?page='+pageId+'&column='+column+'&page_size='+pageSize;
        //   let affiliateId = request.data.affiliateId?request.data.affiliateId:0;   
        //   if(affiliateId) {
        //     ENDPOINT += sepVal+'&affiliate='+affiliateId; 
        //   }
    }
    return service.get(ENDPOINT);    
}; 

export const aflt_rateCardsAll = (request) => {
  let ENDPOINT = URL_BASE_API+'affiliate/rate-card/';
  if(request.data!==undefined){
      let pageId = request.data.page;
      let column = request.data.column;
      let pageSize = request.data.pageSize;
      ENDPOINT = URL_BASE_API+'affiliate/rate-card/?page='+pageId+'&column='+column+'&page_size='+pageSize;
  }
  return service.get(ENDPOINT);    
}; 

export const aflt_rateCardsAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/rate-card/';
  return service.post(ENDPOINT,request.data);  
};  

export const aflt_rateCardsUpdate = (request) => {
  let rateCardId = request.data.id;
  const ENDPOINT = URL_BASE_API+'affiliate/rate-card/'+rateCardId;
  return service.put(ENDPOINT,request.data);
};

export const aflt_rateCardsDelete = (request) => {
  let rateCardId = request.data.rateCardId;
  let confirm = request.data.confirm;
  let ENDPOINT = '';
  if(confirm!==undefined){
    ENDPOINT = URL_BASE_API+'affiliate/rate-card/'+rateCardId+'?delete_confirmation='+confirm;
  }else{
    ENDPOINT = URL_BASE_API+'affiliate/rate-card/'+rateCardId;
  }
  return service.delete(ENDPOINT);  
};  

export const aflt_departmentRateCardsList = (request) => {
  let clientId = request.data.clientId;
  let ENDPOINT = URL_BASE_API+'affiliate/client-rate-cards/?client_id='+clientId;
  return service.get(ENDPOINT);    
}; 

export const aflt_departmentRateCardsUpdate = (request) => {
  let clientId = request.data.clientId;
  const ENDPOINT = URL_BASE_API+'affiliate/client-rate-cards/?client_id='+clientId; 
  return service.post(ENDPOINT,request.data.deptRateCardsData);
}; 

